<template>
    <div>
        <h1 class="title is-3 between-center">
            <span>{{ task.subject }}</span>
            <div class="field is-grouped">
                <p class="control">
                    <router-link :to="{ name: 'tasks.index' }" class="button is-default is-small" >Back</router-link>
                </p>
                <p class="control">
                    <a @click.prevent="confirmCustomDelete" class="button is-danger is-small">Delete</a>
                </p>
                <p class="control">
                    <router-link :to="{ name: 'tasks.edit', params: { slug: 'example' } }" @click.prevent="confirmCustomDelete" class="button is-small is-warning">
                        Edit
                    </router-link>
                </p>
            </div>
        </h1>
        <div class="columns">
            <div class="column is-3">
                <b-panel :collapsible="true">
                  <template #header>
                    <strong>Info</strong>
                  </template>
                    <div class="content full-width">
                        <p class="between-center">
                            <strong>Subject: </strong>
                            <span>{{ task.subject }}</span>
                        </p>
                        <p class="between-center">
                            <strong>Created At: </strong>
                            <span>{{ task.createdAt }}</span>
                        </p>
                        <p class="between-center">
                            <strong>Due Date: </strong>
                            <span>{{ task.dueDate }}</span>
                        </p>
                        <p class="between-center">
                            <strong>Location: </strong>
                            <span>{{ task.location }}</span>
                        </p>
                        <p class="between-center">
                            <strong>Status: </strong>
                            <span>{{ task.status }}</span>
                        </p>
                        <p class="between-center">
                            <strong>Assigned To: </strong>
                            <span>{{ task.assignedTo }}</span>
                        </p>
                    </div>
                </b-panel>
                <b-panel :collapsible="true">
                  <template #header>
                    <strong>Description</strong>
                  </template>
                    <div class="content full-width">
                        <div>{{ task.description }}</div>
                    </div>
                </b-panel>
            </div>
            <div class="column is-9">
                <o-tabs type="is-boxed">
                    <o-tab-item label="Discussion">
                        <article class="media">
                            <figure class="media-left">
                                <p class="image is-64x64">
                                    <img src="http://bulma.io/images/placeholders/128x128.png">
                                </p>
                            </figure>
                            <div class="media-content">
                                <div class="field">
                                    <b-quill v-model="content" />
                                </div>
                                <nav class="level">
                                    <div class="level-left"></div>
                                    <div class="level-right">
                                        <div class="level-item">
                                            <a class="button is-dark">Send</a>
                                        </div>
                                    </div>
                                </nav>
                            </div>
                        </article>
                        <article class="media" v-for="item in new Array(15)">
                            <figure class="media-left">
                                <p class="image is-64x64">
                                    <img src="http://bulma.io/images/placeholders/128x128.png"/>
                                </p>
                            </figure>
                            <div class="media-content">
                                <div class="content">
                                    <p>
                                        <strong>
                                            John Smith
                                        </strong>
                                        <small>
                                            @johnsmith
                                        </small>
                                        <small>
                                            31m
                                        </small>
                                        <br/>

                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ornare magna eros, eu pellentesque tortor vestibulum ut. Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.
                                    </p>
                                </div>
                            </div>
                            <div class="media-right">
                                <button class="delete">
                                </button>
                            </div>
                        </article>
                    </o-tab-item>
                    <o-tab-item label="Files">
                        <div class="block has-text-right">
                            <input type="hidden" role="uploadcare-uploader" data-multiple="true" name="my_file" />
                        </div>
                        <o-table
                            :data="files"
                            :bordered="isBordered"
                            :striped="isStriped"
                            :narrowed="isNarrowed"
                            :checkable="isCheckable"
                            :loading="isLoading"
                            :mobile-cards="hasMobileCards"
                            :paginated="isPaginated"
                            :per-page="perPage"
                            :pagination-simple="isPaginationSimple"
                            default-sort="user.first_name"
                            :selected.sync="selected"
                            :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event">

                            <template slot-scope="props">

                                <o-table-column field="name" label="File Name" sortable>
                                    {{ props.row.name }}
                                </o-table-column>

                                <o-table-column field="size" label="Size" sortable>
                                    {{ props.row.size }}
                                </o-table-column>

                                <o-table-column field="uploadedBy" label="Uploaded By" sortable>
                                    {{ props.row.uploadedBy }}
                                </o-table-column>

                                <o-table-column label="">
                                    <a @click.prevent="confirmCustomDelete" class="button is-danger is-small">Delete</a>
                                </o-table-column>

                            </template>

                            <div slot="empty" class="has-text-centered">
                                No files are uploaded yet
                            </div>
                        </o-table>
                    </o-tab-item>
                </o-tabs >
            </div>
        </div>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isComponentModalActive" has-modal-card="">
            <note-modal/>
        </o-modal>
    </div>
</template>

<script>
    import NoteModal from '../../components/modals/Note';
    import uploadcare from 'uploadcare-widget';

    export default {
        components: {
            NoteModal,
        },

        data() {
            return {
                content: '',
                isComponentModalActive: false,
                task: {
                    subject: 'File Project',
                    createdAt: '01/24/2017',
                    dueDate: '07/12/2017',
                    location: '07/12/2017',
                    status: 'In Progress',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt ratione amet molestias adipisci nihil cum.',
                },
                tableData: [
                    {"id": 1, "name": "Alan Bjorneby", "company": "EAB Architectural Designs", "telephone": "631-319-1047", "mobile": "631-742-3339", "email": "alanb@eabarchitecture.com", "fax": "201-864-0490", "role": "Asbestos Inspector"},
                    {"id": 2, "name": "DJ McCutcheon Jr.", "company": "McCutcheon & McCutcheon, LLC", "telephone": "201-864-0064", "mobile": "631-742-3339", "email": "dj@mccutcheonpa.com", "fax": "201-864-0490", "role": "Architect"},
                ],
                files: [
                    {"id": 1, "name": "XSLT stylesheets", "size": "1 MB", "uploadedBy": "John Doe"},
                    {"id": 1, "name": "Technical Task", "size": "586 KB", "uploadedBy": "Jimmy Doe"},
                ],
                checkedRows: [],
                selected: {},
                isBordered: true,
                isStriped: true,
                isNarrowed: false,
                isCheckable: true,
                isLoading: false,
                hasMobileCards: true,
                isPaginated: true,
                isPaginationSimple: false,
                perPage: 10,
                project: {
                    name: '805 St Marks Ave-Apts A1B & A1K',
                    floor: '001',
                    clientName: 'Akelius Real Estate Management LLC',
                    projectManager: 'Natalia Smith',
                    createdAt: '01/24/2017',
                },
                recentNote: {
                    author: 'Chelsea',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem vitae repudiandae, iusto enim quaerat cum, optio rerum similique dicta minus suscipit. Commodi, et, nihil. Pariatur eos sequi tempora iusto repellat.',
                    createdAt: 'Monday, 7 Aug 2017 07:39 AM',
                }
            }
        },
        methods: {
            clearSelected() {
                this.selected = {}
            },
            clearCheckedRows() {
                this.checkedRows = []
            },
            confirmCustomDelete() {
                this.$swal.fire({
                    title: 'Deleting project',
                    text: 'Are you sure you want to <strong>delete</strong> this project? This action cannot be undone.',
                    confirmText: 'Delete Project',
                    icon: 'error',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$swal.fire('Project deleted!')
                    }
                })
            }
        }
    }
</script>
